import webLogin from '@utils/weblogin';
import util from '@utils/util';
var index = {
  doRecharge: function doRecharge() {
    util.KEWLSensorTrack({
      lmweb_clickText: '跳转',
      lmweb_tabName: 'doRecharge'
    });
    var userInfo = webLogin.getUserInfoData();
    var href = '';
    if (window.bridge && window.bridge.webRecharge) {
      href = window.bridge.webRecharge.doRecharge(userInfo);
      if (href) {
        window.location.href = href;
        return;
      }
    }
    // 
    var project = ['liveme', 'lmpro', 'emolm', 'highlive'].includes(window.baseAxios.alias) ? 'livemepay' : 'livepay';
    var cuHost = location.host == 'www.lmlite.net' ? 'www.royallive.com' : location.host;
    // por\emolm liveme 三个包共用一个账户，所以都要跳转到liveme 的网站 新增highlive
    // pro 支付跳转
    if (window.baseAxios.alias === 'lmpro') {
      cuHost = cuHost.replace('pro.', 'www.');
    }
    // 支付跳转 emolm 属于liveme pro 替代包 
    if (window.baseAxios.alias === 'emolm') {
      cuHost = 'www.liveme.com';
    }
    // highlive 沿用liveme支付
    if (window.baseAxios.alias === 'highlive') {
      cuHost = 'www.liveme.com';
    }
    //TODO: - 工程都改版完，以下代码可以删除
    if (webLogin.checkLogin()) {
      userInfo = webLogin.getUserInfoData();
      var deviceid = userInfo.deviceid;
      var u_country = userInfo.user.country.toUpperCase();
      var area = userInfo.user.area.toUpperCase();
      /*
       *@desc  不同地区的用户登录后使用不同的充值方式
       */

      // 优先按照国家码判断用户，若用户是ID、IN国家的，直接下发idpay或inpay
      switch (u_country) {
        case 'JP':
          // 日本使用自己的充值
          window.location.href = location.protocol + '//' + cuHost + '/app/' + project + '/dist/jppay.html?pay_source=101&from=pc&thirdchannel=6';
          return;
        case 'IN':
          // 日本使用自己的充值
          window.location.href = location.protocol + '//' + cuHost + '/app/' + project + '/dist/inpay.html?pay_source=101&from=pc&thirdchannel=6';
          return;
        case 'ID':
          window.location.href = location.protocol + '//' + cuHost + '/app/' + project + '/dist/idpay.html?pay_source=101&from=pc&thirdchannel=6';
          return;
      }

      // A_CT A_JP  A_US A_ID A_DE A_IN A_VN A_AR A_BR A_GB
      switch (area) {
        case 'A_VN':
          window.location = location.protocol + '//' + cuHost + '/app/pay/vietnam.html?from=pc&thirdchannel=6&uid=' + userInfo.user.uid + "&token=" + userInfo.token + '&deviceid=' + deviceid;
          break;
        case 'A_CT':
          window.location = location.protocol + '//' + cuHost + '/app/' + project + '/dist/twpay.html?pay_source=101&from=pc&thirdchannel=6';
          break;
        case 'A_ID':
          //window.location = location.protocol + '//' + location.host + '/app/pay/index.html?thirdchannel=6&type=32&uid=' + userInfo.user.uid + "&token=" + userInfo.token + '&deviceid=' + deviceid;
          // window.location = location.protocol + '//' + location.host + '/app/pay/idpaychange.html?from=pc&thirdchannel=6&type=32&uid=' + userInfo.user.uid + "&token=" + userInfo.token + '&deviceid=' + deviceid;
          window.location = location.protocol + '//' + cuHost + '/app/' + project + '/dist/idpay.html?pay_source=101&from=pc&thirdchannel=6';
          break;
        case 'A_IN':
          window.location = location.protocol + '//' + cuHost + '/app/' + project + '/dist/inpay.html?pay_source=101&from=pc&thirdchannel=6';
          // window.location = location.protocol + '//' + location.host + '/app/newpay/dist/inpay.html?pay_source=101&from=pc&thirdchannel=6&uid=' + userInfo.user.uid + "&token=" + userInfo.token + '&deviceid=' + deviceid;
          break;
        case 'A_AR':
          window.location = location.protocol + '//' + cuHost + '/app/' + project + '/dist/sapay.html?pay_source=101&from=pc&thirdchannel=6';
          break;
        case 'A_US':
          window.location = location.protocol + '//' + cuHost + '/app/' + project + '/dist/uspay.html?pay_source=101&from=pc&thirdchannel=6';
          break;
        default:
          window.location.href = location.protocol + '//' + cuHost + '/app/' + project + '/dist/uspay.html?pay_source=101&from=pc&thirdchannel=6';
          break;
      }
    } else {
      window.location.href = location.protocol + '//' + cuHost + '/app/' + project + '/dist/uspay.html';
    }
  }
};
export default index;